export default __webpack_public_path__ + "static/media/Hand-wraps of the Shivering Stars.772eaad4.jpg";